import React from 'react'

export type BreadcrumbsItemType = 'client' | 'agency_client' | 'task' | 'store' | 'folder' | 'share'

interface IBreadcrumbsIcon {
  type?: BreadcrumbsItemType
}

const BreadcrumbsIcon = (props: IBreadcrumbsIcon) => {
  const { type } = props
  switch (type) {
    case 'client':
      return (
        <svg width="16px" height="16px">
          <use xlinkHref="#home" />
        </svg>
      )
    case 'agency_client':
      return (
        <svg width="16px" height="16px">
          <use xlinkHref="#profile" />
        </svg>
      )
    case 'task':
      return (
        <svg width="16px" height="16px">
          <use xlinkHref="#checked-square" />
        </svg>
      )
    case 'folder':
      return (
        <svg width="16px" height="16px">
          <use xlinkHref="#folder" />
        </svg>
      )
    case 'share':
      return (
        <svg width="16px" height="16px">
          <use xlinkHref="#share" />
        </svg>
      )
    default:
      return null
  }
}

export default BreadcrumbsIcon
